import { render } from "./CodeReviewFinding.vue?vue&type=template&id=7d8c2da4&scoped=true"
import script from "./CodeReviewFinding.vue?vue&type=script&lang=js"
export * from "./CodeReviewFinding.vue?vue&type=script&lang=js"

import "./codeReview.css?vue&type=style&index=0&id=7d8c2da4&scoped=true&lang=css&external"
import "./CodeReviewFinding.vue?vue&type=style&index=1&id=7d8c2da4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d8c2da4"]])

export default __exports__